// extracted by mini-css-extract-plugin
module.exports = {"table":"OrderProductsTable_table__F36Hb"};